import React, { createContext, useContext } from 'react';

export function GenCtx<V, D>(args: { useLogic: (props: D) => V }) {
  const Ctx = createContext({} as V);

  function useCtx() {
    return useContext(Ctx);
  }

  function Provider({
    ...props
  }: D & {
    children: React.ReactNode | ((value: V) => React.ReactNode);
  }) {
    const valueCtx = args.useLogic(props);
    const renderChildren =
      typeof props.children === 'function' ? props.children(valueCtx) : props.children;

    return <Ctx.Provider value={valueCtx}>{renderChildren}</Ctx.Provider>;
  }

  return {
    useCtx,
    Provider,
    Consumer: Ctx.Consumer,
  };
}
